/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Pick_NoneInputs */

const vi_media_pick_none = /** @type {(inputs: Media_Pick_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn chưa chọn ảnh nào. Bấm vào ảnh trong danh sách để chọn.`)
};

/**

* @param {Media_Pick_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_pick_none = /** @type {((inputs?: Media_Pick_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Pick_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_pick_none(inputs)
});